import { Theme } from "@mui/material/styles";

/**
 * Shared styles for dropdown with icon pattern
 * Used across Investor Request forms for Bank Country dropdowns
 */
export const getDropdownWithIconStyles = (theme: Theme) => ({
  infoIcon: {
    color: theme.palette.common.white,
    width: 16,
    height: 16,
  },
  infoIconWrapper: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    width: 24,
    height: 24,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bankCountryContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  bankCountryDropdown: {
    flex: 1,
    minWidth: 0,
  },
});
